
export const setEmailStatus = (status: boolean): void => {
  sessionStorage.setItem('isEmail', status.toString());
};

export const getEmailStatus = (): boolean => {
  const status = sessionStorage.getItem('isEmail');
  if (status !== undefined && status !== null && status !== "") {
    if (status === "true") {
      return true;
    }
    return false
  }
  return false
};